import { makeCookiebotConsentProvider } from "../../shared/integrations/Cookiebot/cookiebot-consent.js";
export const NOOP_COOKIE_CONSENT_PROVIDER = {
    subscribe: () => () => { },
};
/**
 * The consent manager currently in use. Switching to another one is a change here — or an
 * injected `cookieConsentProvider` on <AnalyticsProvider/> — and nothing else in this layer moves.
 */
export function makeDefaultCookieConsentProvider() {
    return makeCookiebotConsentProvider();
}
